import React from "react";
import Callout from "components/callout/Callout";
import { useTranslation } from "react-i18next";

export default function NoReportsReturned() {
  const { t } = useTranslation();

  return (
    <div className="pt-2">
      <Callout type="error" title={t("No Report Data")} />
    </div>
  );
}
